import moment from 'moment';

const chatbotClosedKey = 'joey.chatbotClosed';

class LocalStorageService {
    public setChatbotClosed() {
        localStorage.setItem(chatbotClosedKey, moment().toISOString());
    }

    public getChatbotClosed() {
        const chatbotClosedString = localStorage.getItem(chatbotClosedKey);
        return chatbotClosedString ? moment(chatbotClosedString) : undefined;
    }
}

export const localStorageService = new LocalStorageService();
